import { Box, Stack, Text } from "@chakra-ui/react";
import { FC } from "react";
import { MdSearch } from "react-icons/md";

type SamedayPickupSetLocationCardProps = {
  setIsDrawerOpen: (isDrawerOpen: boolean) => void;
};

export const SamedayPickupSetLocationCard: FC<
  SamedayPickupSetLocationCardProps
> = ({ setIsDrawerOpen }) => (
  <Box
    display="flex"
    alignItems="center"
    gap="0.5rem"
    cursor="pointer"
    onClick={() => setIsDrawerOpen(true)}
    padding="0.5rem"
    boxShadow="base"
    border="1px solid lightgray"
    borderRadius="6px"
  >
    <MdSearch size={30} color="blue" />
    <Stack>
      <Text as="span" fontSize="md" style={{ margin: 0 }}>
        Same day pickup available
      </Text>
      <Text as="span" fontSize="sm" fontWeight="bold" style={{ margin: 0 }}>
        Set your location
      </Text>
    </Stack>
  </Box>
);
